const EVENT_BUFFER = [];
const PERF_SAMPLE_RATE = Math.max(
  0,
  Math.min(1, Number(import.meta.env.VITE_PERF_SAMPLE_RATE || 1))
);

export function trackEvent(event, payload = {}) {
  if (event === "web_vital" && PERF_SAMPLE_RATE < 1 && Math.random() > PERF_SAMPLE_RATE) {
    return;
  }
  const row = { event, payload, ts: Date.now() };
  EVENT_BUFFER.push(row);
  if (EVENT_BUFFER.length > 300) EVENT_BUFFER.shift();
  const endpoint = import.meta.env.VITE_ANALYTICS_ENDPOINT || "";
  try {
    if (endpoint) {
      const body = JSON.stringify(row);
      if (navigator?.sendBeacon) {
        const blob = new Blob([body], { type: "application/json" });
        navigator.sendBeacon(endpoint, blob);
      } else {
        fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body,
          keepalive: true,
        }).catch(() => {});
      }
    }
  } catch (_) {
    // Never break app flow for telemetry.
  }
  if (import.meta.env.DEV) {
    console.debug("[track]", row.event, row.payload);
  }
}

export function getTrackedEvents() {
  return [...EVENT_BUFFER];
}
